<template>
    <!--@formatter:off-->
    <div class="detail_list">
        <strong class="tit">{{$t('EnrolmentQuestionProgramTimeEditor_title')}}<em class="required" v-if="!isAllowDuplicateApply" >*</em></strong>
        <div class="cont">
            <ul class="list_detail">
                <li
                    v-for="(time, index) in times"
                    :key="`time-${index}`"
                >
                    <CustomSelect
                        :id="`time-day-${questionIndex}-${programIndex}-${index}`"
                        class="bx_sorting3"
                        :options="dayOptions"
                        :value="time.day"
                        :initial-label="$t('EnrolmentQuestionProgramTimeEditor_days').split(',')[0]"
                        @input="setValue({index, name: 'day', value: $event})"
                    />

                    <TextInput
                        :id="`time-startHour-${questionIndex}-${programIndex}-${index}`"
                        wrapper-class="time_inp"
                        input-class=""
                        input-style="background-color: white"
                        type="text"
                        placeholder="00"
                        :is-native-placeholder="true"
                        :title="$t('EnrolmentQuestionProgramTimeEditor_inputHour')"
                        :only-numeric="true"
                        :maxlength="2"
                        :value="time.startHour"
                        @input="setValue({index, name: 'startHour', value: $event})"
                    />

                    <TextInput
                        :id="`time-startMinute-${questionIndex}-${programIndex}-${index}`"
                        wrapper-class="time_inp"
                        input-class=""
                        input-style="background-color: white"
                        type="text"
                        placeholder="00"
                        :is-native-placeholder="true"
                        :title="$t('EnrolmentQuestionProgramTimeEditor_inputMinute')"
                        :only-numeric="true"
                        :maxlength="2"
                        :value="time.startMinute"
                        @input="setValue({index, name: 'startMinute', value: $event})"
                    />

                    <span class="txt">~<span class="blind">{{$t('EnrolmentQuestionProgramTimeEditor_from')}}</span></span>

                    <TextInput
                        :id="`time-endHour-${questionIndex}-${programIndex}-${index}`"
                        wrapper-class="time_inp"
                        input-class=""
                        input-style="background-color: white"
                        type="text"
                        placeholder="00"
                        :is-native-placeholder="true"
                        :title="$t('EnrolmentQuestionProgramTimeEditor_inputHour')"
                        :only-numeric="true"
                        :maxlength="2"
                        :value="time.endHour"
                        @input="setValue({index, name: 'endHour', value: $event})"
                    />

                    <TextInput
                        :id="`time-endMinute-${questionIndex}-${programIndex}-${index}`"
                        wrapper-class="time_inp"
                        input-class=""
                        input-style="background-color: white"
                        type="text"
                        placeholder="00"
                        :is-native-placeholder="true"
                        :title="$t('EnrolmentQuestionProgramTimeEditor_inputMinute')"
                        :only-numeric="true"
                        :maxlength="2"
                        :value="time.endMinute"
                        @input="setValue({index, name: 'endMinute', value: $event})"
                    />

                    <span class="blind">{{$t('EnrolmentQuestionProgramTimeEditor_to')}}</span>

                    <button
                        v-show="isShowDeleteButton(times)"
                        type="button"
                        class="btn_del"
                        @click="remove({index})"
                    >
                        <span class="blind">{{$t('EnrolmentQuestionProgramTimeEditor_remove')}}</span>
                    </button>
                </li>
            </ul>

            <button
                v-show="isShowAdd"
                type="button"
                class="btn_add"
                @click="add"
                v-ga-helper:click="{
                    view_category: '수강신청프로그램',
                    view_area: '시간추가클릭',
                    view_label: '',
                }"
            >{{$t('EnrolmentQuestionProgramTimeEditor_add')}}</button>
        </div>
    </div>
    <!--@formatter:on-->
</template>

<script>
import CustomSelect from '@iamteacherpc/components/common/CustomSelect';
import TextInput from '@iamteacherpc/components/common/TextInput';
import {ADD_PROGRAM_TIME, MAX_PROGRAM_TIME, REMOVE_PROGRAM_TIME} from '@common/store/modules/enrolment/editor';

export default {
    name: "EnrolmentQuestionProgramTimeEditor",
    components: {TextInput, CustomSelect},
    props: {
        questionIndex: {
            type: Number,
            required: true,
        },

        programIndex: {
            type: Number,
            required: true,
        },
    },

    computed: {
        storePath() {
            return `form.questions.${this.questionIndex}.programs.${this.programIndex}`;
        },

        program() {
            return this.$store.getters['enrolment/getField'](this.storePath);
        },

        isAllowDuplicateApply() {
            return this.$store.getters['enrolment/getField'](`form.isAllowDuplicateApply`);
        },

        times: {
            get() {
                return this.$store.getters['enrolment/getField'](`${this.storePath}.times`);
            },
            set(newValue) {
                this.$store.commit('enrolment/updateField', {
                    path: `${this.storePath}.times`,
                    value: newValue,
                });
            },
        },

        isShowAdd() {
            return this.times.length < MAX_PROGRAM_TIME;
        },

        dayOptions() {
            const days = this.$t('EnrolmentQuestionProgramTimeEditor_days');
            return days
                .split(',')
                .map((day, index) => ({
                    label: day,
                    value: index % 7,
                }))
                .filter((_, index) => index > 0);
        },

    },

    methods: {
        setValue({index, name, value}) {
            this.$store.commit('enrolment/updateField', {
                path: `${this.storePath}.times.${index}.${name}`,
                value: value,
            });
        },

        remove({index}) {
            this.$store.dispatch(`enrolment/${REMOVE_PROGRAM_TIME}`, {program: this.program, index});
        },

        add() {
            this.$store.dispatch(`enrolment/${ADD_PROGRAM_TIME}`, {program: this.program});
        },

        isShowDeleteButton(times) {
            return times.length > 1 || this.isAllowDuplicateApply;
        },
    },
}
</script>

<style scoped>

</style>